import { BankConnection } from '@core/model/domain/bankConnection';
import { GetBankConnectionsDto } from '@core/service/digital-factory/bank/types/bankConnectionDto';
import { ConnectionStateEnum } from '@modules/process/pages/login/services/dtos/connection-response';

export const bankConnectionsDto: GetBankConnectionsDto = [
  {
    id: 'a5871207-e4fa-40ca-98a0-734ec59cbd40',
    state: 'valid',
  },
];

export const bankConnections: BankConnection[] = [
  {
    connectionId: 'a5871207-e4fa-40ca-98a0-734ec59cbd40',
    state: ConnectionStateEnum.VALID,
  },
];
